import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout.jsx";
import { ConsentProvider } from "./components/Consent.jsx";
import Home from "./pages/Home.jsx";
import ToolPage from "./pages/ToolPage.jsx";
import NotFound from "./pages/NotFound.jsx";
import { AvisoPrivacidad, Terminos, AcercaDe, Contacto } from "./pages/Legales.jsx";
import { TOOLS } from "./data/tools.js";

export default function App() {
  return (
    <ConsentProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          {TOOLS.map((tool) => (
            <Route key={tool.id} path={`/${tool.slug}`} element={<ToolPage tool={tool} />} />
          ))}
          <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
          <Route path="/terminos-y-condiciones" element={<Terminos />} />
          <Route path="/acerca-de" element={<AcercaDe />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </ConsentProvider>
  );
}
